import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { MARKETING_HERO_CONSTANTS } from 'organisms/MarketingHero/AU/Constants/MarketingConstants';
import CONTEXT_REDUCER_MAPPING_KEY from 'common/constants/ContextReducerKeys';
import { getUserType } from 'common/utilities/utils';
const { TRANSPARENT, FULLBLEED } = MARKETING_HERO_CONSTANTS;
export const useCanonicalUrl = () => {
  const useLocationHook = useLocation();
  const [canonicalUrl, setCanonicalUrl] = useState('');

  useEffect(() => {
    const origin = window?.location?.origin;
    const pathName = useLocationHook?.pathname ?? '';
    setCanonicalUrl(`${origin}${pathName}`);
  }, [useLocationHook?.pathname]);

  return { canonicalUrl };
};
export const useCarousalDataAU = (
  contentData,
  setMarketingAnalyticsOnLoad,
  setFullBleedImage,
  setTransparentImage,
  setVideoItem,
  currencyShortName,
  viewPromotionsVariables,
  userParams,
) => {
  const { localized, loggedIn } = userParams;
  const userType = getUserType(localized, loggedIn);
  const { nextSlideIndex, viewPromotionEventCall, setviewPromotionEventCall, isElementInViewport } =
    viewPromotionsVariables;
  useEffect(() => {
    const selectedData = contentData[nextSlideIndex];
    var ele = document.getElementsByClassName('slick-active')[0];
    if (!viewPromotionEventCall.includes(nextSlideIndex) && isElementInViewport(ele)) {
      setviewPromotionEventCall([...viewPromotionEventCall, nextSlideIndex]);
      setMarketingAnalyticsOnLoad(selectedData, currencyShortName, userType, nextSlideIndex);
    }

    if (selectedData && selectedData.backgroundImageType === FULLBLEED) {
      setFullBleedImage(true);
      setTransparentImage(false);
      setVideoItem(false);
    } else if (selectedData && selectedData.backgroundImageType === TRANSPARENT) {
      setFullBleedImage(false);
      setTransparentImage(true);
      setVideoItem(false);
    } else {
      setTransparentImage(false);
      setFullBleedImage(false);
      setVideoItem(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextSlideIndex]);
};
export const useCarousalDataIN = (
  contentData,
  setMarketingAnalyticsOnLoad,
  currencyShortName,
  viewPromotionsVariables,
  userParams,
) => {
  const { localized, loggedIn } = userParams || {};
  const userType = getUserType(localized, loggedIn);
  const { nextIndex, viewPromotionEventCall, setviewPromotionEventCall, isElementInViewport } = viewPromotionsVariables;
  useEffect(() => {
    const selectedData = contentData?.[nextIndex];
    var ele = document.getElementsByClassName('slick-active')[0];
    if (!viewPromotionEventCall.includes(nextIndex) && isElementInViewport(ele)) {
      setviewPromotionEventCall([...viewPromotionEventCall, nextIndex]);
      setMarketingAnalyticsOnLoad(selectedData, currencyShortName, userType, nextIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextIndex]);
};
export const useShowDisposition = (showDisposition, carousal) => {
  useEffect(() => {
    !showDisposition && carousal?.current?.slickPlay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDisposition]);
};

export const useWiCodeFinaliseStatus = (userParams, authReducer, history, dispatch, getCustomerInfo) => {
  useEffect(() => {
    if (userParams?.loggedIn && !authReducer?.isLoading && history?.location?.isWicodeFinaliseFailed) {
      const reqPayload = {
        updateUserData: true,
      };
      dispatch(getCustomerInfo(reqPayload));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userParams?.loggedIn, authReducer?.isLoading, dispatch, history?.location?.isWicodeFinaliseFailed]);
};

export const useSignedInAPI = params => {
  const { userParams, authReducer, dispatch, getCustomerInfo, userOrderStateDispatch, userOrderState } = params;
  const { existUserIsSignIn } = userOrderState;
  const { EXIST_USER_IS_SIGNIN } = CONTEXT_REDUCER_MAPPING_KEY;
  useEffect(() => {
    if (userParams?.loggedIn && !authReducer?.isLoading && existUserIsSignIn === userParams?.loggedIn) {
      const reqPayload = {
        updateUserData: true,
      };
      dispatch(getCustomerInfo(reqPayload));
    }
    if (!existUserIsSignIn && userParams?.loggedIn) {
      userOrderStateDispatch({
        type: EXIST_USER_IS_SIGNIN,
        value: { existUserIsSignIn: true },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userParams?.loggedIn, authReducer?.isLoading, dispatch, existUserIsSignIn]);
};
